import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    clear_filter_button_history: {
      id: 'clear_filter_button_history',
      defaultMessage: "Clear fiilter",
      description: '',
    },
    save_as_pdf_button_history: {
      id: 'save_as_pdf_button_history',
      defaultMessage: "Save shown records in PDF",
      description: '',
    },
    history_parameters_language: {
      id: 'history_parameters_language',
      defaultMessage: "Language - N5",
      description: '',
    },
    history_parameters_unit_water_hardness: {
      id: 'history_parameters_unit_water_hardness',
      defaultMessage: "Unit of water hardness- N40",
      description: '',
    },
    history_parameters_water_pressure: {
      id: 'history_parameters_water_pressure',
      defaultMessage: "Water pressure for the calculation - N16",
      description: '',
    },
    history_parameters_pressure_sensor: {
      id: 'history_parameters_pressure_sensor',
      defaultMessage: "Pressure sensor  - N8",
      description: '',
    },
    history_parameters_chlorine_generator: {
      id: 'history_parameters_chlorine_generator',
      defaultMessage: "Chlorine generator - N48",
      description: '',
    },
    history_parameters_reserve_period: {
      id: 'history_parameters_reserve_period',
      defaultMessage: "Reserve period- N53",
      description: '',
    },
    history_parameters_reg_period: {
      id: 'history_parameters_reg_period',
      defaultMessage: "Regeneration period- N38",
      description: '',
    },
    history_parameters_days_of_regeneration: {
      id: 'history_parameters_days_of_regeneration',
      defaultMessage: "Days of regeneration - N93",
      description: '',
    },
    history_parameters_date: {
      id: 'history_parameters_date',
      defaultMessage: "Date",
      description: '',
    },
    history_parameters_time: {
      id: 'history_parameters_time',
      defaultMessage: "Time",
      description: '',
    },
    history_parameters_device_type: {
      id: 'history_parameters_device_type',
      defaultMessage: "Device type",
      description: '',
    },
    history_parameters_outlet_water_hardness: {
      id: 'history_parameters_outlet_water_hardness',
      defaultMessage: "Outlet water hardness - N46",
      description: '',
    },
    history_parameters_intlet_water_hardness: {
      id: 'history_parameters_intlet_water_hardness',
      defaultMessage: "Inlet water hardness - N42",
      description: '',
    },
    history_parameters_regenerant_dose: {
      id: 'history_parameters_regenerant_dose',
      defaultMessage: "Regenerant dose - N39",
      description: '',
    },
    history_parameters_resin_volume: {
      id: 'history_parameters_resin_volume',
      defaultMessage: "Resin volume - N84",
      description: '',
    },
    history_parameters_reserve_type: {
      id: 'history_parameters_reserve_type',
      defaultMessage: "Reserve type - N50",
      description: '',
    },
    history_parameters_percentage_of_reserve: {
      id: 'history_parameters_percentage_of_reserve',
      defaultMessage: "Percentage of reserve - N51",
      description: '',
    },
    history_parameters_regeneration_time: {
      id: 'history_parameters_regeneration_time',
      defaultMessage: "Regeneration time - N41",
      description: '',
    },
    history_parameters_average_water_used: {
      id: 'history_parameters_average_water_used',
      defaultMessage: "Average water used - N7",
      description: '',
    },
    history_parameters_ferrum_content: {
      id: 'history_parameters_ferrum_content',
      defaultMessage: "Ferumm content - N43",
      description: '',
    },
    history_parameters_type_of_regeneration: {
      id: 'history_parameters_type_of_regeneration',
      defaultMessage: "Type of regeneration - N49",
      description: '',
    },
    history_parameters_cancel_vacation_mode: {
      id: 'history_parameters_cancel_vacation_mode',
      defaultMessage: "Cancel vacation mode - N9",
      description: '',
    },
    history_parameters_backwash: {
      id: 'history_parameters_backwash',
      defaultMessage: "Backwash Rinsing Time",
      description: '',
    },
    history_parameters_rapid_rinsing: {
      id: 'history_parameters_rapid_rinsing',
      defaultMessage: "Rapid Rinsing Time",
      description: '',
    },
    history_parameters_dhcp_client: {
      id: 'history_parameters_dhcp_client',
      defaultMessage: "DHCP client",
      description: '',
    },
    history_parameters_ip_address: {
      id: 'history_parameters_ip_address',
      defaultMessage: "IP address",
      description: '',
    },
    history_parameters_subnet_mask: {
      id: 'history_parameters_subnet_mask',
      defaultMessage: "Subnet mask",
      description: '',
    },
    history_parameters_default_gateway: {
      id: 'history_parameters_default_gateway',
      defaultMessage: "Default gateway",
      description: '',
    },
    history_parameters_dns_server: {
      id: 'history_parameters_dns_server',
      defaultMessage: "DNS server",
      description: '',
    },
    history_parameters_timezone: {
      id: 'history_parameters_timezone',
      defaultMessage: "Timezone",
      description: '',
    },
    monday_info1_level1_softener: {
      id: 'monday_info1_level1_softener',
      defaultMessage: "Monday",
      description: '',
    },
    tuesday_info1_level1_softener: {
      id: 'tuesday_info1_level1_softener',
      defaultMessage: "Tuesday",
      description: '',
    },
    wednesday_info1_level1_softener: {
      id: 'wednesday_info1_level1_softener',
      defaultMessage: "Wednesday",
      description: '',
    },
    thursday_info1_level1_softener: {
      id: 'thursday_info1_level1_softener',
      defaultMessage: "Thursday",
      description: '',
    },
    friday_info1_level1_softener: {
      id: 'friday_info1_level1_softener',
      defaultMessage: "Friday",
      description: '',
    },
    saturday_info1_level1_softener: {
      id: 'saturday_info1_level1_softener',
      defaultMessage: "Saturday",
      description: '',
    },
    sunday_info1_level1_softener: {
      id: 'sunday_info1_level1_softener',
      defaultMessage: "Sunday",
      description: '',
    },
    immediate_regeneration_parameters_level2_softener: {
      id: 'immediate_regeneration_parameters_level2_softener',
      defaultMessage: "Immediate",
      description: '',
    },
    delayed_regeneration_parameters_level2_softener: {
      id: 'delayed_regeneration_parameters_level2_softener',
      defaultMessage: "Delayed",
      description: '',
    },
    option1_chlorine_generator_parameters_level2_softener: {
      id: 'option1_chlorine_generator_parameters_level2_softener',
      defaultMessage: "Chlorine Generator",
      description: '',
    },
    option2_chlorine_generator_parameters_level2_softener: {
      id: 'option2_chlorine_generator_parameters_level2_softener',
      defaultMessage: "Salt sensor",
      description: '',
    },
    option3_chlorine_generator_parameters_level2_softener: {
      id: 'option3_chlorine_generator_parameters_level2_softener',
      defaultMessage: "Unavailable",
      description: '',
    },
    salt_sensor_history_yes: {
      id: 'salt_sensor_history_yes',
      defaultMessage: "Yes",
      description: '',
    },
    salt_sensor_history_no: {
      id: 'salt_sensor_history_no',
      defaultMessage: "No",
      description: '',
    },
    history_parameters_check_uncheck_all: {
      id: 'history_parameters_check_uncheck_all',
      defaultMessage: "Check/uncheck all",
      description: '',
    },
    history_parameters_superior_date: {
      id: 'history_parameters_superior_date',
      defaultMessage: "Date",
      description: '',
    },
    history_parameters_superior_time: {
      id: 'history_parameters_superior_time',
      defaultMessage: "Time",
      description: '',
    },
    history_parameters_superior_language: {
      id: 'history_parameters_superior_language',
      defaultMessage: "Language",
      description: '',
    },
    history_parameters_superior_device_type: {
      id: 'history_parameters_superior_device_type',
      defaultMessage: "Device type",
      description: '',
    },
    history_parameters_superior_auto_degass_start_1_enable: {
      id: 'history_parameters_superior_auto_degass_start_1_enable',
      defaultMessage: "Auto Degass Start 1 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_start_1_hour: {
      id: 'history_parameters_superior_auto_degass_start_1_hour',
      defaultMessage: "Auto Degass Start 1 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_start_1_minute: {
      id: 'history_parameters_superior_auto_degass_start_1_minute',
      defaultMessage: "Auto Degass Start 1 - minute",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_1_enable: {
      id: 'history_parameters_superior_auto_degass_stop_1_enable',
      defaultMessage: "Auto Degass Stop 1 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_1_hour: {
      id: 'history_parameters_superior_auto_degass_stop_1_hour',
      defaultMessage: "Auto Degass Stop 1 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_1_minute: {
      id: 'history_parameters_superior_auto_degass_stop_1_minute',
      defaultMessage: "Auto Degass Stop 1 - minute",
      description: '',
    },
    history_parameters_superior_auto_degass_start_2_enable: {
      id: 'history_parameters_superior_auto_degass_start_2_enable',
      defaultMessage: "Auto Degass Start 2 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_start_2_hour: {
      id: 'history_parameters_superior_auto_degass_start_2_hour',
      defaultMessage: "Auto Degass Start 2 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_start_2_minute: {
      id: 'history_parameters_superior_auto_degass_start_2_minute',
      defaultMessage: "Auto Degass Start 2 - minute",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_2_enable: {
      id: 'history_parameters_superior_auto_degass_stop_2_enable',
      defaultMessage: "Auto Degass Stop 2 - enable",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_2_hour: {
      id: 'history_parameters_superior_auto_degass_stop_2_hour',
      defaultMessage: "Auto Degass Stop 2 - hour",
      description: '',
    },
    history_parameters_superior_auto_degass_stop_2_minute: {
      id: 'history_parameters_superior_auto_degass_stop_2_minute',
      defaultMessage: "Auto Degass Stop 2 - minute",
      description: '',
    },
    history_parameters_superior_degass_block: {
      id: 'history_parameters_superior_degass_block',
      defaultMessage: "Degassing blocking weekday",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/HistoryParameters/Messages.js